"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = exports.appReducer = exports.history = void 0;
var redux_1 = require("redux");
var connected_react_router_1 = require("connected-react-router");
var history_1 = require("history");
var typesafe_actions_1 = require("typesafe-actions");
var reducers_1 = require("@app/features/auth/state/reducers");
var reducers_2 = require("@app/features/transfers/state/reducers");
var reducers_3 = require("@app/features/registration/state/reducers");
var reducers_4 = require("@app/features/users/state/reducers");
var reducers_5 = require("@app/features/new-packages/state/reducers");
var reducers_6 = require("@app/features/received-packages/state/reducers");
var reducers_7 = require("@app/features/sent-packages/state/reducers");
var reducers_8 = require("@app/features/package-details/state/reducers");
var reducers_9 = require("@app/features/package-files/state/reducers");
var reducers_10 = require("@app/features/pending-uploads/state/reducers");
var reducer_1 = require("@app/features/dashboard/state/reducer");
var actions_1 = require("@app/features/auth/state/actions");
var reducers_11 = require("@app/features/ui/state/reducers");
exports.history = history_1.createBrowserHistory();
exports.appReducer = redux_1.combineReducers({
    router: connected_react_router_1.connectRouter(exports.history),
    auth: reducers_1.authReducer,
    transfers: reducers_2.transfersReducer,
    registration: reducers_3.registrationReducer,
    users: reducers_4.usersReducer,
    newPackages: reducers_5.newPackagesReducer,
    receivedPackages: reducers_6.receivedPackagesReducer,
    sentPackages: reducers_7.sentPackagesReducer,
    packageDetails: reducers_8.packageDetailsReducer,
    packageFiles: reducers_9.packageFilesReducer,
    pendingUploads: reducers_10.pendingUploadsReducer,
    dash: reducer_1.dashboardReducer,
    ui: reducers_11.uiReducer
});
var rootReducer = function (state, action) {
    if (typesafe_actions_1.isActionOf(actions_1.logoutSuccess, action)) {
        state = undefined;
    }
    return exports.appReducer(state, action);
};
exports.rootReducer = rootReducer;
